import { Tooltip, TooltipProps } from "./Tooltip"

export {
  Tooltip
}
export type {
  TooltipProps
}
